window.addEventListener('load', function() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    let validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                let allFormTabs = document.querySelectorAll('#products_tabs_content > .tab-pane');
                [...allFormTabs].forEach((el, i) => {
                    let invalidElements = el.querySelectorAll('.form-control:invalid');
                    let navTab = document.getElementById('product_tab_' + i);
                    let navTabWarningIcon = navTab.querySelector('.icon-exclamation');
                    if (invalidElements.length > 0) {
                        navTabWarningIcon.classList.remove('d-none');
                    } else {
                        navTabWarningIcon.classList.add('d-none');
                    }
                });
                document.querySelector('.form-control:invalid').focus();
            }
            form.classList.add('was-validated');
        }, false);
    });
}, false);
